import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Form, Input, Row } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { get } from "helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import * as api from "../../constants/api_constants";
import Select from "react-select";

function ViewUser() {
  const [roleSelect, setRoleSelect] = useState([]);
  const [userData, setUserData] = useState({
    employeeId: null,
    subscriptionId: "",
    firstname: "",
    lastname: "",
    username: "",
    email: "",
    phone: "",
    role: [],
    companyName: "",
    status: 1,
    description: "",
  });

  const { userId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserData();
    fetchData();
  }, [userId]);


  const fetchData = async () => {
      try {
        const fetchRolesData = await get(api.GET_ROLES_DATA);
        const rolesData = fetchRolesData.rolePermissionPage.content;
        const formattedRoles = rolesData.map((role) => ({
          value: role.id,
          label: role.role,
        }));
        setRoleSelect(formattedRoles);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

  const fetchUserData = async () => {
    try {
      const response = await get(api.GET_USERDATA_BY_ID(userId));
      if (response) {
        setUserData({
          employeeId: response.employeeId || null,
          subscriptionId: response.subscriptionId || "",
          firstname: response.firstName || "",
          lastname: response.lastName || "",
          username: response.userName || "",
          email: response.email || "",
          phone: response.phoneNumber || "",
          role: response.rolePermissions || [],
          companyName: response.companyName || "",
          status: response.status || 1,
          description: response.description || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Function to format status
  const formatStatus = (status) => {
    return status === 1 ? "Active" : "Inactive";
  };

  // Function to format roles
  const formatRoles = (roles) => {
    return roles.map(role => role.role || role).join(", ");
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={"View User"}
            routePath={"Home"}
            pageName={"User Details"}
          />
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form className="row g-3 py-2">
                    <Row className="justify-content-start">
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Employee ID
                        </label>
                        <Input
                          type="text"
                          className="form-control bg-red"
                          value={userData.employeeId || "N/A"}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Subscription ID
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={userData.subscriptionId || "N/A"}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          First Name
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={userData.firstname}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Last Name
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={userData.lastname}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Username
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={userData.username}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Email
                        </label>
                        <Input
                          type="email"
                          className="form-control"
                          value={userData.email}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Phone Number
                        </label>
                        <Input
                          international
                          disabled
                          value={userData.phone}
                          className="form-control d-flex"
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Roles
                        </label>
                        <Select
                          isMulti
                          options={roleSelect}
                          className="form-control"
                          value={roleSelect.filter((roleOption) =>
                            userData.role.includes(roleOption.value)
                          )}
                          isDisabled={true}
                          

                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Company Name
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={userData.companyName || "N/A"}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Status
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={formatStatus(userData.status)}
                          disabled
                        />
                      </Col>
                      <Col md={6} className="mb-3">
                        <label className="col-form-label">
                          Description
                        </label>
                        <Input
                          type="textarea"
                          className="form-control"
                          value={userData.description || "N/A"}
                          disabled
                          rows="3"
                        />
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Footer
          saveText="Edit User"
          save={() => navigate(`/add-user/${userId}`)}
          showBackConfirmation = {false}
        />
      </div>
    </>
  );
}

export default ViewUser;